import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogActions, MatDialogContent, MatDialogRef, MatDialogTitle } from '@angular/material/dialog';
import { MatCheckbox } from '@angular/material/checkbox';
import { FormsModule } from '@angular/forms';
import { MatButton } from '@angular/material/button';
import { DeviceReportColumn } from '../DeviceReportColumn';

export interface DeviceReportSettingsDialogData {
  columns: DeviceReportColumn[];
}

@Component({
  selector: 'app-device-report-settings-dialog',
  imports: [MatDialogTitle, MatDialogContent, MatCheckbox, FormsModule, MatDialogActions, MatButton],
  templateUrl: './device-report-settings-dialog.component.html',
  styleUrl: './device-report-settings-dialog.component.scss',
})
export class DeviceReportSettingsDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<DeviceReportSettingsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DeviceReportSettingsDialogData
  ) {}

  buttonClickedOk(): void {
    this.dialogRef.close(this.data);
  }

  isDialogValid(): boolean {
    // if at least one column is selected
    return this.data.columns.some(value => value.displayed);
  }
}
